import { ICourse } from 'data/entities/course.entity';
import { courseRepository } from 'data/repositories/course.repository';

interface IProps {
    course: ICourse | null;
    moduleIndex: number;
    lessonIndex: number;
    setCourse: React.Dispatch<React.SetStateAction<ICourse | null>>;
}

export const completeLesson = ({ moduleIndex, lessonIndex, course: originalCourse, setCourse }: IProps): void => {
    try {
        if (!originalCourse) throw new Error('Course empty');
        courseRepository.setLessonCompleted(originalCourse.id, moduleIndex, lessonIndex);

        const { modules, progress, ...course } = originalCourse;

        modules[moduleIndex].progress += (1 / modules[moduleIndex].lessons.length) * 100;
        modules[moduleIndex].progressPercent = Math.round(modules[moduleIndex].progress);

        modules[moduleIndex].lessons[lessonIndex].isCompleted = true;

        progress.value += (1 / progress.totalLessons) * 100;
        progress.percent = Math.round(progress.value);

        const incompleteModule = modules.findIndex(({ progressPercent }) => Math.round(progressPercent) !== 100);

        if (incompleteModule !== -1) {
            const nextLesson = modules[incompleteModule].lessons.findIndex(({ isCompleted }) => !isCompleted);
            course.nextLesson = { moduleId: incompleteModule, lessonId: nextLesson };
        }

        setCourse({
            ...course,
            modules,
            progress: {
                ...progress,
                completedLessons: progress.completedLessons += 1,
            },
        });
    } catch ({ message }) {
        console.error('Falha ao definir aula como concluída:', message);
    }
};
